import React from 'react';

import {
  COLOR_SCALE,
  SURFACE_PADDING,
  TYPE_SCALE,
  MARGIN_BOTTOM,
  PADDING_X,
  PADDING_Y,
} from '@/components/design-system/tokens';

// Error boundary fallback component - simplified to avoid translation dependencies
const ErrorFallback: React.FC = () => (
  <div className={`min-h-screen ${COLOR_SCALE['surface-muted']} flex items-center justify-center`}>
    <div className={`text-center ${SURFACE_PADDING['8']}`}>
      <h1
        className={`${TYPE_SCALE['2xl']} font-bold ${COLOR_SCALE.foreground} ${MARGIN_BOTTOM['4']}`}
      >
        Something went wrong
      </h1>
      <p className={`${COLOR_SCALE['foreground-muted']} ${MARGIN_BOTTOM['4']}`}>
        We&apos;re sorry, but something unexpected happened. Please try refreshing the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        className={`${COLOR_SCALE['interactive-primary-bg']} text-white ${PADDING_X['4']} ${PADDING_Y['2']} rounded ${COLOR_SCALE['interactive-primary-bg-hover']}`}
      >
        Reload Page
      </button>
    </div>
  </div>
);

export default ErrorFallback;
